import { createSlice } from '@reduxjs/toolkit';

const initialState = { activeConversationUuid: null, isTopicVisible: false, isTopicClickable: true, failedFetchQuestionsConversationUuid: null, activeConversationHasChatNotEmpty: true };

export const ConversationSlice = createSlice({
    name: 'conversation',
    initialState,
    reducers: {
        setActiveConversationUuid: (state, action) => {
            state.activeConversationUuid = action.payload;
            state.isTopicVisible = false;
        },
        setTriggerTopicFocus: (state, action) => {
            state.isTopicVisible = action.payload;
        },
        setIsTopicClickable: (state, action) => {
            state.isTopicClickable = action.payload;
        },
        setFailedFetchQuestionsConversationUuid: (state, action) => {
            state.failedFetchQuestionsConversationUuid = action.payload;
        },
        setActiveConversationHasChatNotEmpty: (state, action) => {
            state.activeConversationHasChatNotEmpty = action.payload;
        }
    }
});

export const { setActiveConversationUuid, setTriggerTopicFocus, setIsTopicClickable, setFailedFetchQuestionsConversationUuid, setActiveConversationHasChatNotEmpty } = ConversationSlice.actions;

export const selectActiveConversationUuid = (state) => state.conversation.activeConversationUuid;
export const selectIsTopicClickable = (state) => state.conversation.isTopicClickable;
export const selectTriggerTopicFocus = (state) => state.conversation.isTopicVisible;
export const selectFailedFetchQuestionsConversationUuid = (state) => state.conversation.failedFetchQuestionsConversationUuid;
export const selectActiveConversationHasChatNotEmpty = (state) => state.conversation.activeConversationHasChatNotEmpty;

export default ConversationSlice.reducer;